"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./ComparisonTable.scss");
var _ComparisonTableMethods = require("./ComparisonTableMethods");
var _CTAWithHeader = _interopRequireDefault(require("../CTAWithHeader/CTAWithHeader"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
var _blueTick = _interopRequireDefault(require("../../images/blue-tick.svg"));
var _EcommerceCard = _interopRequireDefault(require("../EcommerceCard/EcommerceCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ProductFeaturesMobile = _ref => {
  let {
    productFeatures,
    productDetails,
    productIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, productFeatures?.map((feature, featureIndex) => {
    let attribute = /*#__PURE__*/_react.default.createElement("span", null, "\u2014");
    if (!productDetails) {
      return;
    } else if (productDetails[productIndex]?.productAttributes[featureIndex]?.value === true && feature?.columnName === productDetails[productIndex]?.productAttributes[featureIndex]?.name) {
      attribute = /*#__PURE__*/_react.default.createElement("img", {
        src: _blueTick.default,
        className: "ter-comparison-table__check",
        alt: "Tick Icon",
        "aria-label": "yes"
      });
    } else if (typeof productDetails[productIndex]?.productAttributes[featureIndex]?.value === "string") {
      attribute = productDetails[productIndex]?.productAttributes[featureIndex]?.value;
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      key: `product-feature-${featureIndex}`,
      className: "ter-comparison-table__mobile-carousel-item--features--cell"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__mobile-carousel-item--features--row"
    }, feature?.columnName, feature?.tooltipText && /*#__PURE__*/_react.default.createElement(_ComparisonTableMethods.ComparisonToolTip, {
      column: feature
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__mobile-carousel-item--features--row-text"
    }, attribute));
  }));
};
const VerticalComparisonTableMobileView = _ref2 => {
  let {
    headline,
    subHeading,
    eyebrow,
    description,
    tableVariant,
    tableHeaders,
    comparisonColumnGroups,
    productDetails,
    width,
    headerVariant,
    contentfulId
  } = _ref2;
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);
  const mobileCarouselInner = (0, _react.useRef)(null);
  const formattedComparisonColumnGroups = (0, _ComparisonTableMethods.formatComparisonColumnGroups)(comparisonColumnGroups);
  const updateActiveIndex = index => {
    if (index < 0) {
      index = 0;
    } else if (index >= tableHeaders?.slice(0, 4).length) {
      index = tableHeaders?.slice(0, 4).length - 1;
    }
    setActiveIndex(index);
  };
  tableHeaders?.map(product => {
    // append product features into each existing tableHeaders
    const productFeatures = "productFeatures";
    product[productFeatures] = formattedComparisonColumnGroups;
    return product;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__caption"
  }, /*#__PURE__*/_react.default.createElement(_CTAWithHeader.default, {
    eyebrow: eyebrow,
    headline: headline,
    subhead: subHeading,
    content: description
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__mobile-carousel-indicators--wrapper"
  }, tableHeaders?.slice(0, 4)?.map((_, index) => {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: `page-indicator-${index}`,
      onClick: () => updateActiveIndex(index),
      className: `ter-comparison-table__mobile-carousel-indicators ${index === activeIndex ? "ter-comparison-table__mobile-carousel-indicators--active" : ""}`
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__mobile-carousel"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__mobile-carousel-inner",
    style: {
      transform: `translateX(-${activeIndex * 100}%)`
    },
    ref: mobileCarouselInner
  }, tableHeaders?.slice(0, 4)?.map((item, index) => {
    const cardContent = {
      eyebrow: item?.eyebrow,
      header: item?.header,
      image: item?.image,
      cardLink: item?.cardLink,
      bgColor: !item?.image ? "grey" : "",
      text: item?.text,
      Link: item?.Link,
      cardLabel: item?.cardLabel,
      productPrice: item?.productPrice,
      productPageLink: item?.productPageLink,
      trialLink: item?.trialLink
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-comparison-table__mobile-carousel-item ${activeIndex === index ? "ter-comparison-table__mobile-carousel-item--active" : ""}`,
      key: `item-` + index
    }, headerVariant?.includes("basic header cards") ? /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-comparison-table__mobile-carousel-item--basic-headers",
      "data-sb-object-id": item?.contentfulId ? item?.contentfulId : null
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__mobile-carousel-item--basic-headers-heading",
      "data-sb-field-path": "headerText"
    }, item?.headerText), /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__mobile-carousel-item--basic-headers-description",
      "data-sb-field-path": "textDescription"
    }, item?.textDescription)) : /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-comparison-table__mobile-carousel-item--card"
    }, /*#__PURE__*/_react.default.createElement(_EcommerceCard.default, {
      content: cardContent,
      contentfulId: item?.contentfulId
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-comparison-table__mobile-carousel-item--features"
    }, /*#__PURE__*/_react.default.createElement(ProductFeaturesMobile, {
      productFeatures: item?.productFeatures,
      productDetails: productDetails,
      productIndex: index
    })));
  }))));
};
const renderProductFeaturesTabletView = (productDetails, productFeatures) => {
  return productFeatures?.map((feature, featureIndex) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `feature-${featureIndex}`,
      className: "ter-comparison-table__tablet--product-feature-item",
      "data-sb-object-id": feature?.contentfulId ? feature?.contentfulId : null
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__tablet--product-feature-item__heading"
    }, /*#__PURE__*/_react.default.createElement("span", {
      "data-sb-field-path": "columnName"
    }, feature?.columnName), feature?.tooltipText && /*#__PURE__*/_react.default.createElement(_ComparisonTableMethods.ComparisonToolTip, {
      column: feature
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-comparison-table__tablet--product-feature-item__attributes"
    }, productDetails?.slice(0, 4)?.map((productDetail, productDetailIndex) => {
      let attr = productDetail?.productAttributes[featureIndex];
      let attribute = /*#__PURE__*/_react.default.createElement("span", {
        "data-sb-field-path": "value"
      }, "\u2014");
      if (productDetail?.productAttributes[featureIndex]?.value === true && feature?.columnName === productDetail?.productAttributes[featureIndex]?.name) {
        attribute = /*#__PURE__*/_react.default.createElement("img", {
          src: _blueTick.default,
          className: "ter-comparison-table__check",
          alt: "Tick Icon",
          "aria-label": "yes",
          "data-sb-field-path": "valueBoolean"
        });
      } else if (typeof productDetail?.productAttributes[featureIndex]?.value === "string") {
        attribute = /*#__PURE__*/_react.default.createElement("span", {
          "data-sb-field-path": "value"
        }, productDetail?.productAttributes[featureIndex]?.value);
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        key: `product-${productDetailIndex}`,
        "data-sb-object-id": attr?.contentfulId ? attr?.contentfulId : null
      }, attribute);
    })));
  });
};
const VerticalComparisonTableTabletView = _ref3 => {
  let {
    tableHeaders,
    comparisonColumnGroups,
    productDetails,
    eyebrow,
    headline,
    subHeading,
    description,
    headerVariant,
    contentfulId
  } = _ref3;
  const formattedComparisonColumnGroups = (0, _ComparisonTableMethods.formatComparisonColumnGroups)(comparisonColumnGroups);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__tablet",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__caption"
  }, /*#__PURE__*/_react.default.createElement(_CTAWithHeader.default, {
    eyebrow: eyebrow,
    headline: headline,
    subhead: subHeading,
    content: description
  })), headerVariant?.includes("basic header cards") ? /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__tablet--basic-headers"
  }, tableHeaders?.slice(0, 4)?.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `item-${index}`,
      className: "ter-comparison-table__tablet--basic-headers-item",
      "data-sb-object-id": item?.contentfulId ? item?.contentfulId : null
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__tablet--basic-headers-item--heading",
      "data-sb-field-path": "headerText"
    }, item?.headerText), /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__tablet--basic-headers-item--description",
      "data-sb-field-path": "textDescription"
    }, item?.textDescription));
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__tablet--product-cards"
  }, tableHeaders?.slice(0, 4)?.map((product, index) => {
    const cardContent = {
      eyebrow: product?.eyebrow,
      header: product?.header,
      image: product?.image,
      cardLink: product?.cardLink,
      bgColor: !product?.image ? "grey" : "",
      text: product?.text,
      Link: product?.Link,
      cardLabel: product?.cardLabel,
      productPrice: product?.productPrice,
      productPageLink: product?.productPageLink,
      trialLink: product?.trialLink
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `product-${index}`,
      className: "ter-comparison-table__tablet--product-card"
    }, /*#__PURE__*/_react.default.createElement(_EcommerceCard.default, {
      content: cardContent,
      contentfulId: product?.contentfulId
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-comparison-table__tablet--product-features"
  }, renderProductFeaturesTabletView(productDetails, formattedComparisonColumnGroups)));
};
const StickyTableHeader = _ref4 => {
  let {
    tableHeaders,
    displayStickyHeader,
    headerVariant
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement("tr", {
    className: `ter-comparison-table__row--vertical-scroll ${displayStickyHeader ? "ter-comparison-table__row--vertical-scroll--active" : ""}`
  }, /*#__PURE__*/_react.default.createElement("th", {
    className: `ter-comparison-table__row--vertical-scroll--inner ter-comparison-table__row--vertical-scroll--${tableHeaders?.length}-column`
  }, /*#__PURE__*/_react.default.createElement("span", {
    colSpan: "0",
    "aria-label": "Features"
  }, /*#__PURE__*/_react.default.createElement("span", null)), tableHeaders?.slice(0, 4)?.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: `column-` + index,
      colSpan: item?.comparisonColumns?.length,
      scope: "colgroup",
      className: "ter-comparison-table__row--vertical-scroll__cell"
    }, headerVariant?.includes("product cards") && item?.cardLabel && /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__row--vertical-scroll--product-tag"
    }, item?.cardLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-comparison-table__row--vertical-scroll__cell--title"
    }, headerVariant?.includes("product cards") ? item?.header : item?.headerText));
  })));
};
const ComparisonTable = _ref5 => {
  let {
    data,
    contentfulId
  } = _ref5;
  const {
    headline,
    subHeading,
    eyebrow,
    description,
    comparisonColumnGroups,
    tableHeaders,
    productDetails,
    showImages,
    Link,
    tableVariant,
    headerVariant,
    locale
  } = data;
  const [shadowHeight, setShadowHeight] = (0, _react.useState)(0);
  const [vertScrollbarVisible, setVertScrollbarVisible] = (0, _react.useState)(false);
  const [horzScrollbarVisible, setHorzScrollbarVisible] = (0, _react.useState)(false);
  const [scrollPosition, setScrollPosition] = (0, _react.useState)(0);
  const [displayStickyHeader, setDisplayStickyHeader] = (0, _react.useState)(false);
  const [viewToRender, setViewToRender] = (0, _react.useState)("desktop");
  const tableBody = (0, _react.useRef)(null);
  const {
    width
  } = (0, _useScreenSize.useScreenSize)();
  const updateTableScroll = () => {
    //sets height of internal shadow - since this is position absolute and is within .ter-comparison-table container, the height isn't calculated in the usual way in the DOM.
    //17px comes from the height of the scrollbar inside the table

    let calculatedShadowHeight = tableBody?.current?.offsetHeight;
    if (document && document?.body?.clientWidth > 768) {
      calculatedShadowHeight = tableBody?.current?.offsetHeight - 17;
    }
    tableBody?.current?.offsetHeight && setShadowHeight(calculatedShadowHeight);
    if (tableBody?.current?.offsetHeight > tableBody?.current?.clientHeight) {
      // checks if vertical scrollbars are visible
      setVertScrollbarVisible(true);
    }
    if (tableBody?.current?.offsetWidth > tableBody?.current?.clientWidth) {
      setHorzScrollbarVisible(true);
    }
  };
  (0, _react.useEffect)(() => {
    updateTableScroll();
  });

  // this is to detect scroll to display/hide table sticky header
  (0, _react.useEffect)(() => {
    const updatePosition = () => {
      setScrollPosition(window?.pageYOffset);
    };
    window.addEventListener("scroll", updatePosition);
    updatePosition();
    return () => window.removeEventListener("scroll", updatePosition);
  }, []);

  // determine the top position of the current table
  const heightToHide = {
    top: tableBody?.current?.children[2]?.getBoundingClientRect()?.top,
    bottom: tableBody?.current?.children[2]?.getBoundingClientRect()?.bottom
  };
  (0, _react.useEffect)(() => {
    if (heightToHide?.top <= 0 && heightToHide?.bottom <= 165) {
      setDisplayStickyHeader(false);
    } else if (heightToHide?.top <= 0) {
      setDisplayStickyHeader(true);
    } else {
      setDisplayStickyHeader(false);
    }
  }, [heightToHide]);
  const renderVerticalComparisonTableMobileView = () => {
    return /*#__PURE__*/_react.default.createElement(VerticalComparisonTableMobileView, {
      tableHeaders: tableHeaders,
      comparisonColumnGroups: comparisonColumnGroups,
      productDetails: productDetails,
      width: width,
      headerVariant: headerVariant,
      eyebrow: eyebrow,
      headline: headline,
      subHeading: subHeading,
      description: description,
      contentfulId: contentfulId
    });
  };
  const renderVerticalComparisonTableTabletView = () => {
    return /*#__PURE__*/_react.default.createElement(VerticalComparisonTableTabletView, {
      tableHeaders: tableHeaders,
      comparisonColumnGroups: comparisonColumnGroups,
      productDetails: productDetails,
      eyebrow: eyebrow,
      headline: headline,
      subHeading: subHeading,
      description: description,
      headerVariant: headerVariant,
      contentfulId: contentfulId
    });
  };
  (0, _react.useEffect)(() => {
    if (width <= 600 && tableVariant === "vertical") {
      setViewToRender("mobile");
    } else if (width > 600 && width <= 1119 && tableVariant === "vertical") {
      setViewToRender("tablet");
    } else {
      setViewToRender("desktop");
    }
  }, [width, tableVariant]);
  if (viewToRender === "mobile") return renderVerticalComparisonTableMobileView();
  if (viewToRender === "tablet") return renderVerticalComparisonTableTabletView();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("table", {
    className: `ter-comparison-table ${tableVariant === "vertical" ? "ter-comparison-table--vertical" : ""}`,
    cellSpacing: "0",
    cellPadding: "0",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, tableVariant === "horizontal" && /*#__PURE__*/_react.default.createElement("thead", {
    className: `ter-comparison-table__inner-shadow 
            ${vertScrollbarVisible && `ter-comparison-table__inner-shadow--vert-scrollbar-visible`}
            ${horzScrollbarVisible && `ter-comparison-table__inner-shadow--horz-scrollbar-visible`}
            `,
    style: {
      height: shadowHeight
    }
  }), (0, _ComparisonTableMethods.renderIntro)(headline, subHeading, eyebrow, description, tableVariant, productDetails, Link), /*#__PURE__*/_react.default.createElement("colgroup", {
    key: `column-` + 0,
    colSpan: "0"
  }, /*#__PURE__*/_react.default.createElement("col", {
    className: "ter-comparison-table__comparison-cell"
  })), comparisonColumnGroups.columnGroups?.map((group, index) => {
    return /*#__PURE__*/_react.default.createElement("colgroup", {
      key: `column-` + index,
      colSpan: group?.comparisonColumns?.length
    }, /*#__PURE__*/_react.default.createElement("col", {
      className: "ter-comparison-table__comparison-cell"
    }));
  }), /*#__PURE__*/_react.default.createElement("tbody", {
    className: `ter-comparison-table__wrapper ${tableVariant === "vertical" ? "ter-comparison-table__wrapper--vertical" : ""}`,
    ref: tableBody
  }, tableVariant === "vertical" && /*#__PURE__*/_react.default.createElement(StickyTableHeader, {
    tableHeaders: tableHeaders,
    displayStickyHeader: displayStickyHeader,
    headerVariant: headerVariant
  }), (0, _ComparisonTableMethods.renderTableHeader)(tableVariant, tableHeaders, comparisonColumnGroups, scrollPosition, headerVariant), productDetails && comparisonColumnGroups && (0, _ComparisonTableMethods.renderProductDetailsColumn)(productDetails, showImages, comparisonColumnGroups, Link, tableVariant, headerVariant, locale))), /*#__PURE__*/_react.default.createElement("span", {
    id: "skip-link"
  }));
};
var _default = ComparisonTable;
exports.default = _default;